import { ColorPalette } from '@lumapps/lumx/react';

import { IconProps, NotificationMeta } from '../../types';

export const REACTION_THUMBS_UP: IconProps = {
    color: ColorPalette.primary,
    icon: 'thumb-up',
};

/**
 * Based on the currently enabled FF. Determine the format of the Reaction and return the proper icon.
 * @default 'heart'
 * */
export const getReactionIconProps: NotificationMeta['getIconProps'] = ({
    enabledFeatures,
    iconProps: defaultIconProps,
}) => (enabledFeatures.includes('reaction-thumbs-up') ? REACTION_THUMBS_UP : defaultIconProps);
